/**
 * Checks if expectedShippingDate was changed from a different value than null
 * based on the order history log
 */
export function isExpectedShippingDateChangedFromNonNull(
    historyLog: HistoryEntry[]
): boolean {
    for (const historyEntry of historyLog) {
        if (!historyEntry.what || !Array.isArray(historyEntry.what)) {
            continue;
        }

        for (const change of historyEntry.what) {
            // Check if this change is for expectedShippingDate
            if (
                change.path &&
                Array.isArray(change.path) &&
                change.path.length === 1 &&
                change.path[0] === 'expectedShippingDate'
            ) {
                if (change.lhs) {
                    return true;
                }
            }
        }
    }

    return false;
}

/**
 * Type definitions for the history log structure
 */
interface HistoryChange {
    kind: 'E' | 'N' | 'D' | 'A'; // Edit, New, Delete, Array
    path: string[];
    lhs?: unknown; // left-hand side (old value)
    rhs?: unknown; // right-hand side (new value)
    index?: number; // for array changes
    item?: unknown; // for array changes
}

interface HistoryEntry {
    what: HistoryChange[];
    _id: string;
    who: string;
    when: string;
}
